export const parseErrorCodeToMessage = (
  errorCode?: string | undefined,
  validationMessages?:
    | Record<string, string | undefined | null>
    | undefined
    | null,
) => {
  if (!errorCode) return undefined;

  return validationMessages?.[errorCode] || errorCode;
};
